








































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

import { getFieldError } from "@/core/tools/forms/get_field_error";

import { STORE_KEY, store } from "./_store";
import { resolveCatalogEntityId } from "../utils/openCatalogEntity";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "document",
      "form",
      "meta"
    ]),
    ...mapGetters(STORE_KEY, ["fields"]),
    ...mapState("ubic", ["token"])
  },
  methods: {
    getFieldError
  },
  validations() {
    return {
      form: {
        name: { required, minLength: minLength(3) },
        code: {},
        teaser: {},
        pick_up_product: {},
        type_id: { required },
        business_scope_ids: {},
        trade_mark_id: {}
      }
    };
  },
  components: {}
})
export default class ProductForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any;
  form!: any;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.debug("[ProductForm.prepareNew]", {
      isNew: this.isNew,
      type_id: this.initParams && this.initParams.type_id
    });
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      const entityId = resolveCatalogEntityId(this, this.documentPreview);
      if (entityId != null) {
        this.$store.dispatch(`${STORE_KEY}/init`, { id: entityId });
      }
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field,
      newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
  }

  saveFormData() {
    this.$v.form.$touch();

    if (!this.$v.form.$error) {
      this.$store
        .dispatch(
          `${STORE_KEY}/saveForm`,
          resolveCatalogEntityId(this, this.documentPreview)
        )
        .then(() => {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          this.$v.form.$reset();
          this.$emit("form-close");
          (this.$parent as any).close();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          });
        });
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
  }
}
